export const sv = {
  "account": {
    "k1": "Startpaket",
    "k2": "Erhåll 125 krediter. Perfekt för att komma igång och utforska kärnfunktionerna.",
    "k3": "Pro-paket",
    "k4": "Erhåll 250 krediter. Det mest fördelaktiga valet för regelbundna användare.",
    "k5": "Företagspaket",
    "k6": "Erhåll 1700 krediter. För avancerade användare och företag, med 25 % rabatt.",
    "k7": "Enterprise-paket",
    "k8": "Erhåll 5000 krediter. Den ultimata lösningen för institutionella klienter, med 50 % rabatt.",
    "k9": "Laddar kontouppgifter...",
    "k10": "Kontohantering",
    "k11": "Aktuella krediter",
    "k12": "Nya användare får 125 krediter, motsvarande $50, för att komma igång!",
    "k13": "Dina krediter börjar ta slut. Köp fler för att fortsätta använda AI-funktionerna utan avbrott.",
    "k14": "Har du en kupongkod?",
    "k15": "Lös in kod",
    "k16": "Köp fler krediter",
    "k17": "Köp nu"
  },
  "aIChatWindow": {
    "k1": "Växla AI-assistent",
    "k2": "AI-assistent",
    "k3": "Fråga om din portfölj",
    "k4": "Hur kan jag hjälpa dig idag?",
    "k5": "Ställ en fråga..."
  },
  "allActivities": {
    "k1": "Laddar aktiviteter...",
    "k2": "Fullständig logg över kreditförbrukning",
    "k3": "Inga aktiviteter att visa."
  },
  "auth": {
    "k1": "CRE Dominion",
    "k2": "Skapa konto",
    "k3": "Välkommen tillbaka",
    "k4": "Registrera dig för att komma igång",
    "k5": "Logga in på ditt konto",
    "k6": "E-postadress",
    "k7": "Lösenord",
    "k8": "Eller fortsätt med",
    "k9": "Google",
    "k10": "Har du redan ett konto? Logga in",
    "k11": "Har du inget konto? Registrera dig"
  },
  "bulkLeaseUploader": {
    "k1": "Läser in fastigheter...",
    "k2": "Fel:",
    "k3": "Uppladdning av hyresavtal",
    "k4": "Fastighet (obligatoriskt):",
    "k5": "Välj en fastighet",
    "k6": "Inga fastigheter hittades. Vänligen lägg till en fastighet först.",
    "k7": "Ladda upp filer",
    "k8": "Ladda upp mapp",
    "k9": "Välj hyresavtal (PDF, bilder):",
    "k10": "Välj mapp med hyresavtal (laddar upp alla PDF/bilder i mappen):",
    "k11": "Ladda upp hyresavtal",
    "k12": "Valda",
    "k13": "fil",
    "k14": "Historik för uppladdade hyresavtal",
    "k15": "Läser in historik...",
    "k16": "Ingen uppladdningshistorik hittades.",
    "k17": "Jobb-ID",
    "k18": "Uppladdat",
    "k19": "Antal filer",
    "k20": "Status",
    "k21": "Åtgärder",
    "k22": "Visa"
  },
  "bulkLeaseValidator": {
    "k1": "Läser in jobb för bulkvalidering...",
    "k2": "Laddar upp filer... Denna process kan ta tid beroende på antal och storlek på dokumenten. Du kan navigera vidare; processen fortsätter i bakgrunden.",
    "k3": "Inga poster hittades för detta jobb-ID.",
    "k4": "Bulkvalidering av hyresavtal (Jobb-ID:",
    "k5": "Tillbaka till uppladdning av hyresavtal",
    "k6": "Godkänner valda...",
    "k7": "Godkänn valda hyresavtal",
    "k8": "Godkänner alla...",
    "k9": "Godkänn alla väntande hyresavtal",
    "k10": "Filnamn",
    "k11": "Status",
    "k12": "Åtgärder",
    "k13": "Fel:"
  },
  "calendarEventModal": {
    "k1": "Typ:",
    "k2": "Start:",
    "k3": "Slut:",
    "k4": "Fastighets-ID:",
    "k5": "System-ID för hyresavtal:",
    "k6": "Anpassat ID för hyresavtal:",
    "k7": "Händelse-ID:",
    "k8": "Stäng"
  },
  "calendarView": {
    "k1": "Läser in kalender...",
    "k2": "Fel:",
    "k3": "Kalender för kritiska datum"
  },
  "calendarViewWrapper": {
    "k1": "Kalender"
  },
  "dashboard": {
    "k1": "Instrumentpanel",
    "k2": "Fel:",
    "k3": "Ingen data tillgänglig för instrumentpanelen.",
    "k4": "Totalt antal fastigheter",
    "k5": "Totalt antal hyresgäster",
    "k6": "Totalt antal hyresavtal",
    "k7": "Hyresavtal som löper ut",
    "k8": "Fastighetsbeläggning",
    "k9": "Fastighetstyper",
    "k10": "Trender för vakansgrad"
  },
  "dealSourcing": {
    "k1": "Läser in affärsmöjligheter...",
    "k2": "Fel:",
    "k3": "Sourcing och hantering av affärsmöjligheter",
    "k4": "Redigera affär",
    "k5": "Lägg till ny affär",
    "k6": "Affärsnamn",
    "k7": "Välj affärstyp",
    "k8": "Förvärv",
    "k9": "Avyttring",
    "k10": "Utveckling",
    "k11": "Välj status",
    "k12": "Pipeline",
    "k13": "Due Diligence",
    "k14": "Avslutad",
    "k15": "Förlorad",
    "k16": "Koppla till fastighet (valfritt)",
    "k17": "Målpris",
    "k18": "Budpris",
    "k19": "Slutdatum:",
    "k20": "Källa",
    "k21": "Beskrivning",
    "k22": "Uppdatera affär",
    "k23": "Lägg till affär",
    "k24": "Avbryt redigering",
    "k25": "Mina affärer",
    "k26": "Inga affärer hittades. Lägg till en ovan!",
    "k27": "Status:",
    "k28": "Fastighet:",
    "k29": "Målpris:",
    "k30": "Budpris:",
    "k31": "Källa:",
    "k32": "Beskrivning:",
    "k33": "Redigera",
    "k34": "Ta bort"
  },
  "documents": {
    "k1": "Läser in dokument...",
    "k2": "Fel:",
    "k3": "Dokumenthantering",
    "k4": "Ladda upp nytt dokument",
    "k5": "Fastighet (obligatorisk):",
    "k6": "Välj fastighet",
    "k7": "Välj dokument:",
    "k8": "Ladda upp dokument",
    "k9": "Dina dokument",
    "k10": "Inga dokument hittades. Ladda upp ett ovan!",
    "k11": "Typ:",
    "k12": "Fastighets-ID:",
    "k13": "Beskrivning:",
    "k14": "Uppladdat:",
    "k15": "Visa",
    "k16": "Redigera",
    "k17": "Ta bort"
  },
  "editCompModal": {
    "k1": "Redigera jämförelseobjekt",
    "k2": "Adress:",
    "k3": "Försäljningsdatum:",
    "k4": "Försäljningspris:",
    "k5": "Area (kvm):",
    "k6": "Avbryt",
    "k7": "Spara ändringar"
  },
  "editDocumentModal": {
    "k1": "Redigera dokument",
    "k2": "Filnamn:",
    "k3": "Beskrivning:",
    "k4": "Avbryt",
    "k5": "Spara ändringar"
  },
  "editLeaseModal": {
    "k1": "Redigera hyresavtal",
    "k2": "Anpassat avtals-ID:",
    "k3": "Hyresgäst:",
    "k4": "Startdatum:",
    "k5": "Slutdatum:",
    "k6": "Hyresbelopp:",
    "k7": "Avbryt",
    "k8": "Spara ändringar"
  },
  "editTransactionModal": {
    "k1": "Redigera transaktion",
    "k2": "Typ:",
    "k3": "Beskrivning:",
    "k4": "Belopp:",
    "k5": "Förfallodatum:",
    "k6": "Betaldatum:",
    "k7": "Kategori:",
    "k8": "Intäkt",
    "k9": "Utgift",
    "k10": "Avbryt",
    "k11": "Spara ändringar"
  },
  "fAQ": {
    "k1": "Vad är CRE Dominion?",
    "k2": "CRE Dominion är en heltäckande, AI-driven plattform utformad för yrkesverksamma inom kommersiella fastigheter (CRE). Den effektiviserar fastighetsförvaltning, affärsgenerering, avtalstolkning, marknadsanalys och mycket mer, vilket hjälper dig att fatta datadrivna beslut för att bygga ditt fastighetsimperium.",
    "k3": "Vem vänder sig CRE Dominion till?",
    "k4": "CRE Dominion är byggt för en bred grupp av CRE-proffs, inklusive fastighetsägare, förvaltare, asset managers, mäklare och investerare. Oavsett om du förvaltar en enskild fastighet eller en stor portfölj, tillhandahåller vår plattform de verktyg du behöver för att lyckas.",
    "k5": "Vilka är nyckelfunktionerna i CRE Dominion?",
    "k6": "Våra nyckelfunktioner inkluderar AI-driven avtalstolkning, avancerad affärsgenerering och analys, omfattande fastighets- och hyresgästhantering, marknadsanalys och prediktiva trender, fastighetsvärdering, anpassningsbar rapportering samt säker dokumenthantering.",
    "k7": "Hur fungerar funktionen för avtalstolkning?",
    "k8": "Vårt AI-drivna verktyg för avtalstolkning extraherar automatiskt nyckelinformation från dina hyresavtal, såsom start- och slutdatum, hyresbelopp, klausuler med mera. Detta sparar otaliga timmar av manuell datainmatning och minskar risken för fel.",
    "k9": "Är min data säker?",
    "k10": "Ja, datasäkerhet är vår högsta prioritet. Vi använder branschledande säkerhetsåtgärder, inklusive kryptering och säker molnlagring, för att skydda din känsliga information. Din data är säker, skyddad och alltid tillgänglig för dig.",
    "k11": "Vilken typ av fastigheter kan jag hantera med CRE Dominion?",
    "k12": "Du kan hantera en mängd olika kommersiella fastigheter, inklusive kontorsbyggnader, butikslokaler, industrifastigheter och flerbostadshus.",
    "k13": "Hur fungerar funktionen för affärsgenerering?",
    "k14": "Vår modul för affärsgenerering använder avancerade algoritmer och marknadsdata för att hjälpa dig identifiera och utvärdera potentiella investeringsmöjligheter som matchar dina kriterier. Du kan analysera affärer, utföra due diligence och följa din pipeline på ett och samma ställe.",
    "k15": "Kan jag generera anpassade rapporter?",
    "k16": "Ja, vår plattform inkluderar en kraftfull rapportmotor som gör att du kan generera ett brett utbud av anpassningsbara rapporter om portföljprestanda, ekonomi, leasingaktivitet och mer. Dessa rapporter kan skräddarsys för att möta dina intressenters behov.",
    "k17": "Vilken prismodell tillämpas?",
    "k18": "CRE Dominion tillämpar ett flexibelt kreditsystem. Du köper krediter som används för att få tillgång till våra AI-drivna funktioner och avancerade analysverktyg. Detta innebär att du endast betalar för din faktiska förbrukning och kan skala upp i takt med dina specifika behov. Besök dina kontoinställningar för att se alternativ för kreditköp och detaljerad användningsstatistik.",
    "k19": "Hur kommer jag igång?",
    "k20": "Det är enkelt att komma igång! Du kan registrera dig för en kostnadsfri testperiod direkt via vår webbplats. När du har registrerat dig kan du omedelbart börja lägga till fastigheter och utforska plattformens funktioner.",
    "k21": "&larr; Tillbaka till startsidan",
    "k22": "Vanliga frågor"
  },
  "financialsLedger": {
    "k1": "Läser in finansiell data...",
    "k2": "Fel:",
    "k3": "Intäkter",
    "k4": "Utgifter",
    "k5": "Inga",
    "k6": "poster hittades.",
    "k7": "Typ",
    "k8": "Beskrivning",
    "k9": "Belopp",
    "k10": "Förfallodatum",
    "k11": "Betalningsdatum",
    "k12": "Åtgärder",
    "k13": "Redigera",
    "k14": "Ta bort",
    "k15": "Lägg till ny finansiell transaktion",
    "k16": "Kategori",
    "k17": "Utgift",
    "k18": "Transaktionstyp",
    "k19": "Lägg till transaktion",
    "k20": "Finansiell översikt"
  },
  "homePage": {
    "k1": "Starter Pack",
    "k2": "Perfekt för initial screening av affärsmöjligheter och test av AI-baserad avtalstolkning.",
    "k3": "Pro Pack",
    "k4": "Optimalt för aktiva förvärvsteam, mäklare och kapitalförvaltare.",
    "k5": "Business Pack",
    "k6": "För nischade fonder, family offices och förvärvsprocesser med hög volym.",
    "k7": "Enterprise Pack",
    "k8": "Institutionell skala för REITs, skuldfonder och stora portföljer.",
    "k9": "CRE Dominion | AI-driven plattform för kommersiell fastighetsanalys & avtalshantering",
    "k10": "CRE Dominion-logotyp",
    "k11": "Live-analysverktyg",
    "k12": "Prissättning",
    "k13": "Kunskapsbank",
    "k14": "Kontakt",
    "k15": "Logga in",
    "k16": "Institutionell fastighetsanalys",
    "k17": "På 10 sekunder. Helt utan kalkylark.",
    "k18": "Sluta förlora affärer på grund av långsam manuell due diligence. CRE Dominion kombinerar automatiserad AI-avtalstolkning med institutionell finansiell modellering för amerikanska Cap Rates, brittiska Net Initial Yields och europeiska mätetal.",
    "k19": "Starta Live-analysverktyget ↓",
    "k20": "Kom igång gratis (125 krediter)",
    "k21": "Inget kreditkort krävs",
    "k22": "Kompatibelt med USA, Storbritannien & Norden/EU",
    "k23": "125 kostnadsfria startkrediter",
    "k24": "Automatisering av institutionella arbetsflöden",
    "k25": "Hela ert kommersiella arbetsflöde, samlat i en plattform.",
    "k26": "Utvecklad från grunden för förvärvschefer, mäklare och private equity-aktörer som kräver snabbhet utan att kompromissa med revisionskraven.",
    "k27": "AI-baserad avtalstolkning på 10 sekunder",
    "k28": "Extrahera nyckeldatum, hyresjusteringar, uppsägningsklausuler, försäkringsåtaganden och hyresgästförpliktelser från 80-sidiga kontrakt på sekunder med 99,9 % precision.",
    "k29": "Finansiell modellering för flera jurisdiktioner",
    "k30": "Inbyggd modellering för amerikanska Triple Net (NNN) Cap Rates, brittiska Full Repairing & Insuring (FRI) Net Initial Yields och nordiska/europeiska hyresavtal (`m²`).",
    "k31": "AI-driven affärsgenerering & pipeline",
    "k32": "Centralisera potentiella förvärv, bevaka budgivningsdeadlines, hantera analysstatus och generera investerarklara sammanfattningar i en enhetlig pipeline.",
    "k33": "Prediktiv marknadsanalys",
    "k34": "Prognostisera förändringar i Cap Rate, vakanstrender och hyrestillväxt på delmarknader med hjälp av historisk telemetri och jämförbar marknadsdata i realtid.",
    "k35": "Omedelbar värdering & DCF-scenarier",
    "k36": "Kör kassaflödesanalyser (DCF), direktavkastningsmodeller och jämförande försäljningsanalyser sida vid sida för att stresstesta exit-avkastning och belånad avkastning.",
    "k37": "Enterprise Vault & SOC-säkerhet",
    "k38": "Isolerad Google Cloud-lagring med strikt IAM-auktorisering. Era proprietära hyreslistor, T-12-rapporter och avtal delas aldrig och matas aldrig in i publika LLM:er.",
    "k39": "Interaktiv live-demo",
    "k40": "Testa vår AI-motor för hyresavtal på valfri klausul",
    "k41": "Klistra in en hyresklausul (skadeslöshetsförbindelse, uppsägningsklausul, KPI-indexering, samnyttjande) eller ladda upp ett ensidigt avtal nedan. Få en omedelbar riskbedömning och analys av förhandlingsutrymmet.",
    "k42": "Transparent och suverän prissättning",
    "k43": "Betala endast för det du analyserar.",
    "k44": "Inga obligatoriska årsavtal på 5 000 USD per användare. Inga säljdemonstrationer. Kom igång direkt med 125 kostnadsfria startkrediter vid registrering och fyll på allteftersom din portfölj växer.",
    "k45": "Mest populär",
    "k46": "engångsbelopp",
    "k47": "Ca.",
    "k48": "Analyskrediter",
    "k49": "Kom igång →",
    "k50": "Behöver du anpassad företagsvolym, lokala installationer (on-premise) eller dedikerade API-kvoter? Kontakta vårt ingenjörsteam på",
    "k51": "Sluta gå miste om intäkter.",
    "k52": "Anslut dig till CRE-proffs som använder AI för att automatisera avtalstolkning, hitta off-market-affärer och maximera portföljens ROI i USA, Storbritannien och Europa.",
    "k53": "Kom igång gratis →",
    "k54": "Testa affärsgranskaren",
    "k55": "Inget kreditkort krävs • Omedelbar kontokonfigurering med 125 gratis krediter",
    "k56": "Operativsystem för kommersiella fastigheter med hög precision. Automatiserad AI-avtalstolkning, kalkylmodeller för underwriting och portföljintelligens.",
    "k57": "&copy;",
    "k58": "CRE Dominion. Alla rättigheter förbehållna.",
    "k59": "Facebook",
    "k60": "Instagram",
    "k61": "LinkedIn",
    "k62": "Google Play",
    "k63": "Integritetspolicy",
    "k64": "Användarvillkor",
    "k65": "FAQ"
  },
  "kPISection": {
    "k1": "Visa detaljer"
  },
  "leaseAbstraction": {
    "k1": "Avtalstolkning",
    "k2": "Välj fastighet:",
    "k3": "-- Välj en fastighet --",
    "k4": "Ladda upp hyresavtal (PDF, PNG, JPG):",
    "k5": "Ladda upp & tolka",
    "k6": "Extraherade hyresavtal",
    "k7": "Hyresavtals-ID:",
    "k8": "Status:",
    "k9": "Extraherad avtalsdata (ID:",
    "k10": "Godkänn hyresavtal",
    "k11": "Redigera hyresavtal",
    "k12": "Ta bort hyresavtal",
    "k13": "Spara ändringar",
    "k14": "Avbryt",
    "k15": "Fastighets-ID:",
    "k16": "Dokument-URL:",
    "k17": "Visa dokument",
    "k18": "AI-extraherad data:",
    "k19": "Startdatum för hyresavtal:",
    "k20": "Slutdatum för hyresavtal:",
    "k21": "Månadshyra:",
    "k22": "Deposition:",
    "k23": "Hyresgäst:",
    "k24": "Hyresvärd:",
    "k25": "Fastighetsadress:",
    "k26": "Ingen specifik data extraherad.",
    "k27": "Fullständig extraherad text:"
  },
  "leaseAbstractionSettings": {
    "k1": "Läser in inställningar för avtalstolkning...",
    "k2": "Inställningar för avtalstolkning",
    "k3": "Välj fördefinierade klausuler:",
    "k4": "Övrigt (specificera nedan)",
    "k5": "Anpassade klausuler (kommaseparerade):",
    "k6": "t.ex. förtida uppsägningsklausul, rätt till andrahandsuthyrning",
    "k7": "Spara avtalsklausuler"
  },
  "leaseExpirationChart": {
    "k1": "Antal utgående hyresavtal",
    "k2": "Hyresavtal som löper ut per månad",
    "k3": "Antal hyresavtal"
  },
  "leases": {
    "k1": "Fel:",
    "k2": "Hyresavtal",
    "k3": "Avbryt tillägg av nytt hyresavtal",
    "k4": "Lägg till nytt hyresavtal",
    "k5": "Uppladdning av hyresavtal",
    "k6": "Avtalstolkning",
    "k7": "Fastighets-ID:",
    "k8": "Välj fastighet",
    "k9": "Anpassat hyresavtals-ID (valfritt):",
    "k10": "Anpassat hyresavtals-ID",
    "k11": "Hyresgäst:",
    "k12": "Välj hyresgäst",
    "k13": "Startdatum för hyresavtal:",
    "k14": "Slutdatum för hyresavtal:",
    "k15": "Månadshyra:",
    "k16": "Månadshyra",
    "k17": "Hyrestyp:",
    "k18": "Hyrestyp",
    "k19": "Hyresperiod (månader):",
    "k20": "Hyresperiod (månader)",
    "k21": "Status:",
    "k22": "Aktiv",
    "k23": "Väntar på granskning",
    "k24": "Utgånget",
    "k25": "Avslutat",
    "k26": "Anteckningar",
    "k27": "Skapa hyresavtal",
    "k28": "Avbryt",
    "k29": "Redigera hyresavtal (ID:",
    "k30": "Fastighet:",
    "k31": "Välj hyresgäst (valfritt)",
    "k32": "Uppdatera hyresavtal",
    "k33": "Inga hyresavtal hittades",
    "k34": "Hyresavtal:",
    "k35": "System-ID:",
    "k36": "Hyresvärd:",
    "k37": "Löptid:",
    "k38": "till",
    "k39": "Hyra:",
    "k40": "Deposition:",
    "k41": "Redigera",
    "k42": "Ta bort",
    "k43": "Visa dokument",
    "k44": "Rådata",
    "k45": "Extraherad rådata",
    "k46": "Stäng",
    "k47": "Ta bort hyresavtal"
  },
  "marketAnalysis": {
    "k1": "&larr; Tillbaka till fastigheter",
    "k2": "Marknadsanalys",
    "k3": "Hämtar analys...",
    "k4": "Hämta marknadsanalys",
    "k5": "Spara resultat",
    "k6": "Laddar analys...",
    "k7": "Marknadsanalys för fastighet",
    "k8": "Objektspecifikationer",
    "k9": "Adress:",
    "k10": "Fastighetstyp:",
    "k11": "Area (kvm):",
    "k12": "Jämförbar marknadsdata",
    "k13": "Hittade jämförbara objekt:",
    "k14": "Genomsnittspris per kvm (jämförelseobjekt):",
    "k15": "Genomsnittligt försäljningspris (jämförelseobjekt):",
    "k16": "Genomsnittlig area (jämförelseobjekt):",
    "k17": "Marknadskommentar:",
    "k18": "Sammanfattning:",
    "k19": "Huvudtrender:",
    "k20": "Rekommendation:"
  },
  "marketComps": {
    "k1": "Läser in marknadsjämförelser...",
    "k2": "Fel:",
    "k3": "Lägg till ny jämförelseförsäljning",
    "k4": "Adress",
    "k5": "Försäljningsdatum",
    "k6": "Försäljningspris",
    "k7": "Area (kvm)",
    "k8": "Lägg till jämförelseobjekt",
    "k9": "Marknadsjämförelser",
    "k10": "Inga marknadsjämförelser tillgängliga.",
    "k11": "Pris/kvm",
    "k12": "Åtgärder",
    "k13": "Redigera",
    "k14": "Ta bort"
  },
  "navbar": {
    "k1": "CRE Dominion",
    "k2": "Kärnfunktioner",
    "k3": "Instrumentpanel",
    "k4": "Fastigheter",
    "k5": "Hyresgäster",
    "k6": "Hyresavtal",
    "k7": "Dokument",
    "k8": "Avtalstolkning",
    "k9": "Ladda upp hyresavtal",
    "k10": "Tillväxt",
    "k11": "Affärsgenerering",
    "k12": "Underwriting",
    "k13": "Konto",
    "k14": "Logga ut"
  },
  "occupancyChart": {
    "k1": "Beläggningsgrad",
    "k2": "Aktuell uthyrningsgrad",
    "k3": "Procentandel (%)"
  },
  "overduePaymentsSection": {
    "k1": "Förfallna betalningar",
    "k2": "Förfallodatum:",
    "k3": "Avtals-ID:",
    "k4": "Inga förfallna betalningar."
  },
  "predictiveTrends": {
    "k1": "&larr; Tillbaka till fastigheter",
    "k2": "Prediktiva trender",
    "k3": "Ange ett fastighets-ID...",
    "k4": "Hämtar trender...",
    "k5": "Hämta prediktiva trender",
    "k6": "Spara resultat",
    "k7": "Trendprediktion för fastighet",
    "k8": "Måldatum:",
    "k9": "Predikterat värde:",
    "k10": "Konfidensgrad:",
    "k11": "Motivering:",
    "k12": "Fel:",
    "k13": "Rådata:"
  },
  "privacyPolicy": {
    "k1": "&larr; Tillbaka till startsidan",
    "k2": "Integritetspolicy för CRE Dominion",
    "k3": "Denna integritetspolicy beskriver hur CRE Dominion (\"vi\", \"oss\" eller \"vår\") samlar in, använder och delar din information när du använder vår webbapplikation (\"Tjänsten\"). Vi är fast beslutna att skydda din integritet och hantera dina data på ett öppet och transparent sätt.",
    "k4": "Insamling och användning av information",
    "k5": "Vi samlar in olika typer av information för att tillhandahålla och förbättra vår Tjänst för dig. När du loggar in med Google samlar vi in personuppgifter såsom namn och e-postadress från ditt Google-konto. Denna information används för att skapa och hantera ditt användarkonto inom CRE Dominion samt för att anpassa din upplevelse. När du använder Tjänsten kan du förse oss med ytterligare data, inklusive fastighetsdetaljer, hyresavtal, hyresgästinformation och annan fastighetsrelaterad data. Detta användargenererade innehåll lagras och bearbetas för att leverera Tjänstens kärnfunktionalitet, såsom avtalstolkning, fastighetsförvaltning och marknadsanalys. Vi samlar även in användningsdata, vilket kan inkludera information som din dators IP-adress, webbläsartyp, webbläsarversion, vilka sidor i vår Tjänst du besöker, tid och datum för ditt besök, tid spenderad på dessa sidor, unika enhetsidentifierare och annan diagnostisk data. Denna data hjälper oss att förstå hur vår Tjänst används och gör det möjligt för oss att förbättra dess prestanda och funktioner.",
    "k6": "Datalagring och bearbetning",
    "k7": "Din data, inklusive personuppgifter och användargenererat innehåll, lagras och bearbetas via Google Clouds ekosystem, inklusive Google Cloud SQL för databashantering, Google Cloud Storage för dokumentlagring samt Google Clouds Vertex AI och Gemini för avancerad analys och maskininlärningsfunktioner som avtalstolkning och trendprediktion. Vi säkerställer att lämpliga säkerhetsåtgärder finns på plats för att skydda din data när den bearbetas av dessa tjänster.",
    "k8": "Cookies och spårningsteknik",
    "k9": "Vi använder cookies och liknande spårningsteknik för att följa aktivitet i vår Tjänst och lagra viss information. Cookies är filer med en liten mängd data som skickas till din webbläsare från en webbplats och lagras på din enhet. Spårningsteknik som även används inkluderar beacons, taggar och skript för att samla in och spåra information samt för att förbättra och analysera vår Tjänst. Du kan instruera din webbläsare att neka alla cookies eller att ange när en cookie skickas. Om du inte accepterar cookies kan det dock hända att du inte kan använda vissa delar av vår Tjänst.",
    "k10": "Datadelning och utlämnande",
    "k11": "Vi säljer inte dina personuppgifter. Vi kan dela din information med tredjepartsleverantörer för att underlätta vår Tjänst, tillhandahålla Tjänsten å våra vägnar, utföra tjänster relaterade till Tjänsten eller hjälpa oss att analysera hur vår Tjänst används. Dessa tredje parter har endast tillgång till dina personuppgifter för att utföra dessa uppgifter å våra vägnar och är förpliktigade att inte avslöja eller använda dem för något annat ändamål. Vi kan även lämna ut dina personuppgifter i god tro att en sådan åtgärd är nödvändig för att följa en rättslig förpliktelse, skydda och försvara CRE Dominions rättigheter eller egendom, förhindra eller utreda eventuella felaktigheter i samband med Tjänsten, skydda den personliga säkerheten för användare av Tjänsten eller allmänheten, eller skydda mot rättsligt ansvar.",
    "k12": "Datalagringstid",
    "k13": "Vi sparar endast dina personuppgifter så länge det är nödvändigt för de syften som anges i denna integritetspolicy. Vi behåller och använder dina personuppgifter i den utsträckning som krävs för att uppfylla våra rättsliga förpliktelser, lösa tvister samt upprätthålla våra juridiska avtal och policys.",
    "k14": "Dina dataskyddsrättigheter",
    "k15": "Beroende på din geografiska plats kan du ha följande dataskyddsrättigheter: rätt till tillgång, uppdatering eller radering av den information vi har om dig; rätt till rättelse; rätt att göra invändningar; rätt till begränsning av behandling; rätt till dataportabilitet samt rätt att återkalla samtycke. För att utöva någon av dessa rättigheter, vänligen kontakta oss via uppgifterna nedan.",
    "k16": "Begäran om radering av konto och data",
    "k17": "Meddelande om efterlevnad av Google Play-policy för dataradering:",
    "k18": "CRE Dominion ger användare full kontroll över sitt konto och sina personuppgifter. Du har när som helst rätt att begära radering av ditt konto och all tillhörande personlig data.",
    "k19": "Så här begär du radering av konto och data:",
    "k20": "Skicka ett e-postmeddelande till",
    "k21": "med ämnesraden",
    "k22": "\"Account Deletion Request\"",
    "k23": "Inkludera den registrerade e-postadressen som är kopplad till ditt CRE Dominion-konto.",
    "k24": "Vårt supportteam kommer att behandla din begäran om radering inom 7 arbetsdagar och bekräfta när processen är slutförd.",
    "k25": "Data som raderas permanent:",
    "k26": "Autentiseringsuppgifter för konto (e-post, namn, profiluppgifter, UID).",
    "k27": "Uppladdade hyresavtal, PDF-filer och lagrat innehåll i dokumentvalv.",
    "k28": "Sparade fastighetsprofiler, hyresgästlistor och finansiella värderingsrapporter.",
    "k29": "Undantag för datalagring:",
    "k30": "Vissa anonymiserade systemloggar eller transaktions- och faktureringsuppgifter kan lagras temporärt för att uppfylla rättsliga förpliktelser, finansiell revision eller krav på bedrägeribekämpning enligt tillämplig lagstiftning.",
    "k31": "Barns integritet",
    "k32": "Vår tjänst är inte avsedd för barn under 13 år (\"Barn\"). Vi samlar inte medvetet in personligt identifierbar information från personer under 13 år. Om du är förälder eller vårdnadshavare och är medveten om att ditt barn har tillhandahållit oss personuppgifter, vänligen kontakta oss. Om vi blir medvetna om att vi har samlat in personuppgifter från barn utan verifierat föräldrasamtycke, vidtar vi åtgärder för att radera informationen från våra servrar.",
    "k33": "Ändringar i denna integritetspolicy",
    "k34": "Vi kan komma att uppdatera vår integritetspolicy från tid till annan. Vi meddelar dig om eventuella ändringar genom att publicera den nya integritetspolicyn på denna sida. Vi rekommenderar att du regelbundet granskar denna integritetspolicy för eventuella ändringar. Ändringar i denna integritetspolicy träder i kraft när de publiceras på denna sida.",
    "k35": "Kontakta oss",
    "k36": "Om du har frågor om denna integritetspolicy eller önskar begära radering av data, vänligen kontakta oss på support@credominion.com."
  },
  "properties": {
    "k1": "Fel:",
    "k2": "Fastigheter",
    "k3": "Redigera fastighet",
    "k4": "Lägg till ny fastighet",
    "k5": "Auto-extrahera från OM",
    "k6": "System-ID:",
    "k7": "Adress",
    "k8": "Stad",
    "k9": "Delstat",
    "k10": "Postnummer",
    "k11": "Fastighetstyp",
    "k12": "Fastighets-ID (valfritt)",
    "k13": "Area (kvadratfot)",
    "k14": "Antal enheter",
    "k15": "Köpeskilling",
    "k16": "Aktuellt marknadsvärde",
    "k17": "Byggår",
    "k18": "Beskrivning",
    "k19": "Uppdatera fastighet",
    "k20": "Lägg till fastighet",
    "k21": "Avbryt redigering",
    "k22": "Dina fastigheter",
    "k23": "Inga fastigheter hittades",
    "k24": "Typ:",
    "k25": "Storlek:",
    "k26": "kvadratfot",
    "k27": "Enheter:",
    "k28": "Köpeskilling:",
    "k29": "Aktuellt värde:",
    "k30": "Byggår:",
    "k31": "Beskrivning:",
    "k32": "Redigera",
    "k33": "Ta bort",
    "k34": "Marknadsanalys",
    "k35": "Värdering",
    "k36": "Prediktiva trender",
    "k37": "Ta bort fastighet"
  },
  "propertyDetailView": {
    "k1": "Läser in fastighetsdetaljer...",
    "k2": "Fel:",
    "k3": "&larr; Tillbaka till fastigheter",
    "k4": "Fastighets-ID:",
    "k5": "Fastighets-ID",
    "k6": "System-ID",
    "k7": "Fastighetstyp",
    "k8": "Area (kvadratfot)",
    "k9": "kvadratfot",
    "k10": "Antal enheter",
    "k11": "Köpeskilling",
    "k12": "Aktuellt värde",
    "k13": "Byggår",
    "k14": "Beskrivning"
  },
  "propertyDocuments": {
    "k1": "Läser in dokument...",
    "k2": "Fel:",
    "k3": "Fastighetsdokument",
    "k4": "Inga dokument hittades för denna fastighet.",
    "k5": "Typ:",
    "k6": "Beskrivning:",
    "k7": "Uppladdad:",
    "k8": "Visa",
    "k9": "Redigera",
    "k10": "Ta bort"
  },
  "propertyInsights": {
    "k1": "Visa mindre",
    "k2": "Visa mer",
    "k3": "Läser in fastighetsinsikter...",
    "k4": "Fel:",
    "k5": "Fastighetsinsikter (AI-extraherade)",
    "k6": "Inga AI-extraherade insikter tillgängliga för denna fastighet ännu.",
    "k7": "Detaljer:",
    "k8": "Källutdrag:",
    "k9": "Extraherad den:"
  },
  "propertyLeases": {
    "k1": "Läser in hyresavtal...",
    "k2": "Fel:",
    "k3": "Fastighetsavtal",
    "k4": "Inga avtal hittades för denna fastighet.",
    "k5": "Hyresavtal:",
    "k6": "System-ID:",
    "k7": "Hyresgäst:",
    "k8": "Startdatum:",
    "k9": "Slutdatum:",
    "k10": "Hyra:",
    "k11": "Visa",
    "k12": "Redigera",
    "k13": "Ta bort"
  },
  "propertyTypeChart": {
    "k1": "Antal fastigheter",
    "k2": "Fastighetsfördelning per typ"
  },
  "publicNavbar": {
    "k1": "CRE Dominion",
    "k2": "Hem",
    "k3": "Live-analys",
    "k4": "Kunskapsbank",
    "k5": "Kontakt",
    "k6": "Logga in"
  },
  "quickActionsSection": {
    "k1": "Snabbåtgärder",
    "k2": "Lägg till fastighet",
    "k3": "Lägg till hyresavtal",
    "k4": "Ladda upp dokument",
    "k5": "Onboarding",
    "k6": "Välkommen till CRE-Dominion!",
    "k7": "Följ dessa enkla steg för att komma igång:",
    "k8": "Lägg till din första fastighet:",
    "k9": "Navigera till sektionen \"Fastigheter\" och klicka på \"Lägg till fastighet\". Detta utgör grunden för all din fastighetsförvaltning.",
    "k10": "Ladda upp hyresavtal:",
    "k11": "När du har lagt till en fastighet, gå till dess detaljsida och ladda upp tillhörande hyresavtal. Vår AI hjälper dig att extrahera nyckelinformation.",
    "k12": "Hantera dokument:",
    "k13": "Använd sidan \"Dokument\" för att ladda upp övriga relevanta filer, såsom finansiella rapporter eller marknadsanalyser.",
    "k14": "Utforska funktioner:",
    "k15": "Fördjupa dig i \"Marknadsjämförelser\", \"Finansiella data\" och \"Kalender\" för att se hur CRE-Dominion kan effektivisera din verksamhet. Tveka inte att utforska möjligheterna!",
    "k16": "Jag förstår!"
  },
  "recentActivitySection": {
    "k1": "Senaste aktivitet",
    "k2": "Ingen nylig aktivitet.",
    "k3": "Visa mer"
  },
  "summaryReportSection": {
    "k1": "Läser in sammanfattningsrapport...",
    "k2": "Fel:",
    "k3": "Sammanfattningsrapport",
    "k4": "Totalt antal fastigheter",
    "k5": "Totalt antal hyresgäster",
    "k6": "Totalt antal dokument",
    "k7": "Genomsnittlig månadshyra"
  },
  "tenants": {
    "k1": "Läser in hyresgäster...",
    "k2": "Fel:",
    "k3": "Hyresgäster",
    "k4": "Redigera hyresgäst",
    "k5": "Lägg till ny hyresgäst",
    "k6": "Förnamn",
    "k7": "Efternamn",
    "k8": "E-post",
    "k9": "Telefonnummer",
    "k10": "Födelsedatum:",
    "k11": "Uppdatera hyresgäst",
    "k12": "Lägg till hyresgäst",
    "k13": "Avbryt redigering",
    "k14": "Dina hyresgäster",
    "k15": "Inga hyresgäster hittades. Lägg till en ovan!",
    "k16": "E-post:",
    "k17": "Telefon:",
    "k18": "Födelsedatum:",
    "k19": "Redigera",
    "k20": "Ta bort"
  },
  "termsOfService": {
    "k1": "&larr; Tillbaka till startsidan",
    "k2": "Användarvillkor för CRE Dominion",
    "k3": "Välkommen till CRE Dominion. Dessa användarvillkor (\"Villkoren\") reglerar din åtkomst till och användning av CRE Dominions webbplats och tjänster (gemensamt kallade \"Tjänsten\"). Genom att få åtkomst till eller använda Tjänsten godkänner du att vara bunden av dessa Villkor. Om du inte godkänner någon del av villkoren får du inte använda Tjänsten.",
    "k4": "Användarkonton",
    "k5": "När du skapar ett konto hos oss måste du tillhandahålla information som är korrekt, fullständig och aktuell vid varje tidpunkt. Underlåtenhet att göra detta utgör ett brott mot Villkoren, vilket kan leda till omedelbar avslutning av ditt konto i vår Tjänst. Du ansvarar för att skydda det lösenord du använder för att få åtkomst till Tjänsten samt för alla aktiviteter eller åtgärder som utförs under ditt lösenord, oavsett om lösenordet används för vår Tjänst eller en tredjepartstjänst. Du samtycker till att inte röja ditt lösenord för någon tredje part. Du måste omedelbart meddela oss om du blir medveten om ett säkerhetsbrott eller obehörig användning av ditt konto.",
    "k6": "Acceptabel användning",
    "k7": "Du samtycker till att inte använda Tjänsten för något olagligt ändamål eller något ändamål som är förbjudet enligt dessa Villkor. Du samtycker till att inte använda Tjänsten på ett sätt som kan skada, inaktivera, överbelasta eller försämra Tjänsten eller störa någon annan parts användning och upplevelse av Tjänsten. Du får inte erhålla eller försöka erhålla material eller information genom metoder som inte avsiktligt gjorts tillgängliga eller tillhandahållits via Tjänsten.",
    "k8": "Immateriella rättigheter",
    "k9": "Tjänsten och dess ursprungliga innehåll (exklusive innehåll som tillhandahålls av användare), funktioner och funktionalitet är och förblir den exklusiva egendomen hos CRE Dominion och dess licensgivare. Tjänsten skyddas av upphovsrätt, varumärkesrätt och andra lagar i både USA och andra länder. Våra varumärken och vår grafiska profil får inte användas i samband med någon produkt eller tjänst utan föregående skriftligt medgivande från CRE Dominion. Du behåller alla rättigheter till det innehåll du skickar in, publicerar eller visar på eller genom Tjänsten.",
    "k10": "Länkar till andra webbplatser",
    "k11": "Vår Tjänst kan innehålla länkar till tredjepartswebbplatser eller tjänster som inte ägs eller kontrolleras av CRE Dominion. CRE Dominion har ingen kontroll över och tar inget ansvar för innehåll, integritetspolicyer eller praxis hos tredjepartswebbplatser eller tjänster. Du bekräftar och godkänner vidare att CRE Dominion inte ska hållas ansvarigt, direkt eller indirekt, för skada eller förlust som orsakats eller påstås ha orsakats av eller i samband med användning av eller tillit till sådant innehåll, varor eller tjänster som finns tillgängliga på eller via sådana webbplatser eller tjänster. Vi rekommenderar starkt att du läser villkoren och integritetspolicyerna för alla tredjepartswebbplatser eller tjänster som du besöker.",
    "k12": "Avslutande av konto",
    "k13": "Vi kan avsluta eller stänga av ditt konto omedelbart, utan föregående meddelande eller ansvar, av vilken anledning som helst, inklusive men inte begränsat till om du bryter mot Villkoren. Vid avslutande upphör din rätt att använda Tjänsten omedelbart. Om du vill avsluta ditt konto kan du helt enkelt sluta använda Tjänsten.",
    "k14": "Ansvarsfriskrivning",
    "k15": "Din användning av Tjänsten sker på egen risk. Tjänsten tillhandahålls i befintligt skick (\"AS IS\") och i mån av tillgänglighet (\"AS AVAILABLE\"). Tjänsten tillhandahålls utan garantier av något slag, vare sig uttryckliga eller underförstådda, inklusive, men inte begränsat till, underförstådda garantier om säljbarhet, lämplighet för ett visst ändamål, icke-intrång eller prestation. CRE Dominion garanterar inte att Tjänsten kommer att fungera oavbrutet, säkert eller vara tillgänglig vid någon specifik tidpunkt eller plats; att eventuella fel eller brister kommer att korrigeras; att Tjänsten är fri från virus eller andra skadliga komponenter; eller att resultaten av att använda Tjänsten kommer att uppfylla dina krav.",
    "k16": "Ansvarsbegränsning",
    "k17": "Under inga omständigheter ska CRE Dominion, eller dess styrelseledamöter, anställda, partners, agenter, leverantörer eller dotterbolag, hållas ansvariga för några indirekta, oförutsedda, särskilda, följdskador eller straffskadestånd, inklusive men inte begränsat till förlust av vinst, data, användning, goodwill eller andra immateriella förluster, som uppstår till följd av (i) din åtkomst till eller användning av, eller oförmåga att få åtkomst till eller använda tjänsten; (ii) agerande eller innehåll från tredje part i tjänsten; (iii) innehåll som erhållits från tjänsten; och (iv) obehörig åtkomst, användning eller ändring av dina överföringar eller ditt innehåll, oavsett om det grundar sig på garanti, avtal, skadeståndsrätt (inklusive vårdslöshet) eller någon annan juridisk teori, oavsett om vi har informerats om möjligheten till sådan skada, och även om en rättelse som anges häri visar sig ha misslyckats med sitt väsentliga syfte.",
    "k18": "Tillämplig lag",
    "k19": "Dessa villkor ska styras av och tolkas i enlighet med lagarna i delstaten Kalifornien, USA, utan hänsyn till dess lagvalsprinciper. Vår underlåtenhet att utöva en rättighet eller bestämmelse i dessa villkor ska inte anses som ett avstående från dessa rättigheter. Om någon bestämmelse i dessa villkor anses ogiltig eller ogenomförbar av en domstol, ska de återstående bestämmelserna i dessa villkor förbli i kraft. Dessa villkor utgör hela avtalet mellan oss angående vår tjänst och ersätter alla tidigare avtal vi kan ha haft mellan oss angående tjänsten.",
    "k20": "Ändringar av villkor",
    "k21": "Vi förbehåller oss rätten att, efter eget gottfinnande, ändra eller ersätta dessa villkor när som helst. Om en revidering är väsentlig kommer vi att sträva efter att ge minst 30 dagars varsel innan några nya villkor träder i kraft. Vad som utgör en väsentlig ändring avgörs efter vårt eget gottfinnande. Genom att fortsätta att få åtkomst till eller använda vår tjänst efter att dessa revideringar har trätt i kraft, godkänner du att vara bunden av de reviderade villkoren. Om du inte godkänner de nya villkoren, vänligen sluta använda tjänsten.",
    "k22": "Kontakta oss",
    "k23": "Om du har några frågor om dessa villkor, vänligen kontakta oss på support@credominion.com."
  },
  "underwritingToolkit": {
    "k1": "Verktygslåda för fastighetsvärdering",
    "k2": "Indata för fastighet & finansiering",
    "k3": "Köpeskilling",
    "k4": "Bruttoårsintäkt (hyra)",
    "k5": "Övrig årsintäkt (t.ex. parkering, tvättstuga)",
    "k6": "Vakansgrad (%)",
    "k7": "Årliga driftskostnader",
    "k8": "Årliga investeringsutgifter (CapEx)",
    "k9": "Lånebelopp",
    "k10": "Räntesats (%)",
    "k11": "Lånetid (år)",
    "k12": "Transaktionskostnader (%)",
    "k13": "Nyckeltal",
    "k14": "Effektiv bruttointäkt",
    "k15": "Driftsnetto (NOI)",
    "k16": "Direktavkastningskrav (Cap Rate)",
    "k17": "Totalt investerat kapital",
    "k18": "Årlig skuldtjänst",
    "k19": "Årligt kassaflöde",
    "k20": "Direktavkastning på eget kapital (Cash-on-Cash)",
    "k21": "Skuldtäckningsgrad (DSCR)",
    "k22": "Bruttohyresmultiplikator (GRM)",
    "k23": "Belåningsgrad (LTV)"
  },
  "upcomingPaymentsSection": {
    "k1": "Kommande betalningar (30 dagar)",
    "k2": "Förfallodatum:",
    "k3": "Hyresavtals-ID:",
    "k4": "Inga kommande betalningar."
  },
  "vacancyRateChart": {
    "k1": "Trender för vakansgrad"
  },
  "valuation": {
    "k1": "&larr; Tillbaka till fastigheter",
    "k2": "Fastighetsvärdering",
    "k3": "Jämförbara försäljningar",
    "k4": "Direktavkastningsmetod",
    "k5": "Diskonterat kassaflöde (DCF)",
    "k6": "Produktionskostnadsmetod",
    "k7": "Hämtar värdering...",
    "k8": "Utför värdering",
    "k9": "Spara resultat",
    "k10": "Laddar värdering...",
    "k11": "Värdering för fastighet",
    "k12": "Värderingssammanfattning:",
    "k13": "Rekommenderat slutvärde:",
    "k14": "Värderingsdatum:",
    "k15": "Värderingsmetod:",
    "k16": "Antaganden:",
    "k17": "Ansvarsfriskrivning:",
    "k18": "Värderingsdetaljer:"
  },
  "articleCard": {
    "k1": "Publicerad:",
    "k2": "Läs mer"
  },
  "leaseInsightWidget": {
    "k1": "AI-driven CRE-analys",
    "k2": "Analysera hyresavtal, finansiella rapporter eller marknadsanalyser omedelbart.",
    "k3": "Klistra in klausul eller sammanfattning",
    "k4": "t.ex. 'Hyresgästen har rätt att säga upp detta avtal om hyresvärden underlåter att tillhandahålla...'",
    "k5": "Byt dokument",
    "k6": "Ladda upp PDF/Doc",
    "k7": "Stöder PDF upp till 5MB",
    "k8": "Utför analys nu →",
    "k9": "Bearbetar intelligens...",
    "k10": "Testgräns uppnådd",
    "k11": "Skapa kostnadsfri arbetsyta →",
    "k12": "Tillbaka till widget",
    "k13": "Konfidensnivå:",
    "k14": "Återställ",
    "k15": "Executive Summary",
    "k16": "Strategisk handlingsplan",
    "k17": "Lås upp professionell portföljanalys →"
  },
  "bottomCTA": {
    "k1": "Sluta lämna pengar",
    "k2": "på bordet.",
    "k3": "Anslut dig till över 500 CRE-proffs som använder AI för att automatisera avtalstolkning, hitta off-market-affärer och maximera portföljens ROI.",
    "k4": "Kom igång kostnadsfritt →",
    "k5": "Inget kreditkort krävs"
  },
  "insufficientCreditsModal": {
    "k1": "Krediter förbrukade",
    "k2": "Du har förbrukat dina aktiva krediter. Fyll på nu för att låsa upp obegränsad AI-baserad avtalstolkning, prediktiv analys och automatiserade kalkylverktyg.",
    "k3": "Omedelbar avtalstolkning",
    "k4": "Extrahera nyckelvillkor och finansiella detaljer omedelbart.",
    "k5": "Verktygslåda för underwriting",
    "k6": "Generera granulära värderingar och prognostisera avkastning.",
    "k7": "Prediktiv trendprognos",
    "k8": "Simulera geografiska och prisrelaterade skiften över tid.",
    "k9": "Motor för marknadsanalys",
    "k10": "Kör jämförelseanalyser och makroutvärderingar.",
    "k11": "Köp kreditpaket",
    "k12": "Få 125 krediter för 50 USD för att fortsätta bearbeta affärer.",
    "k13": "Hämta krediter"
  },
  "contact": {
    "k1": "Kontakta CRE Dominion | Institutionell plattform för kommersiella fastigheter",
    "k2": "Kontakta CRE Dominion",
    "k3": "CRE Dominion",
    "k4": "Direkt assistans",
    "k5": "Har du frågor om AI-baserad avtalstolkning, värderingsarbetsflöden eller företagsintegrationer för portföljer? Vårt team av fastighetsteknologer finns här för att hjälpa dig.",
    "k6": "Kund- och teknisk support",
    "k7": "För kontofrågor, verifiering av avtalstolkning och teknisk support.",
    "k8": "SLA: Under 4 arbetstimmar",
    "k9": "Förfrågan har skickats",
    "k10": "Tack för att du kontaktar CRE Dominion. Ditt meddelande har dirigerats till",
    "k11": ". Om din e-postklient inte öppnades automatiskt, klicka nedan för att verifiera eller skicka direkt från din e-post.",
    "k12": "Öppna i e-postprogram",
    "k13": "Skicka ett nytt meddelande",
    "k14": "Skicka en förfrågan",
    "k15": "Fullständigt namn *",
    "k16": "Sarah Connor",
    "k17": "Arbets-e-post *",
    "k18": "Företag / Portfölj",
    "k19": "Apex Asset Management",
    "k20": "Typ av förfrågan",
    "k21": "Allmän support",
    "k22": "Enterprise-licensiering",
    "k23": "API-integration",
    "k24": "Fakturering & Prenumeration",
    "k25": "Säkerhet & Efterlevnad",
    "k26": "Meddelande *",
    "k27": "Beskriv dina portföljbehov, fastighetsvolymer eller tekniska frågor...",
    "k28": "Skyddad av TLS 1.3-kryptering. Vi delar aldrig din kommersiella data.",
    "k29": "Skicka förfrågan",
    "k30": "Vanliga frågor &rarr;",
    "k31": "Integritetspolicy",
    "k32": "Användarvillkor",
    "k33": "CRE Knowledge Hub"
  },
  "instantUnderwritingWidget": {
    "k1": "⚡ Interaktivt Underwriting-verktyg",
    "k2": "Ingen inloggning krävs",
    "k3": "Institutionell CRE-underwriting & avkastningsmodellering",
    "k4": "Växla mellan amerikanska, brittiska och europeiska fastighetsstandarder. Omedelbar matematisk verifiering av nyckeltal.",
    "k5": "🇺🇸 USA",
    "k6": "🇬🇧 Storbritannien",
    "k7": "🇪🇺 Norden &amp; Europa",
    "k8": "Europeisk valuta:",
    "k9": "kr",
    "k10": "Kompatibel med nordisk KPI-indexering &amp; metriska standarder (`m²`)",
    "k11": "Snabbval för tillgångar:",
    "k12": "🏢 Kommersiella kontor",
    "k13": "🏭 Logistik / Industri",
    "k14": "🏬 Blandad användning / Flerbostadshus",
    "k15": "Köpeskilling / Värdering (",
    "k16": "Bruttohyresintäkt / år (",
    "k17": "Total uthyrningsbar area (",
    "k18": "Vakansgrad (%)",
    "k19": "Driftskostnader / år (",
    "k20": "Antaganden för skuld &amp; finansiering",
    "k21": "Belåningsgrad (LTV) (",
    "k22": "Räntesats (",
    "k23": "Amortering (",
    "k24": "år)",
    "k25": "Direkt avkastningsprofil",
    "k26": "Verifierad formel",
    "k27": "Driftsnetto (NOI)",
    "k28": "Cash-on-Cash-avkastning",
    "k29": "Skuldtäckningsgrad (DSCR)",
    "k30": "Kontantköp",
    "k31": "Direktavkastning (Gross Yield)",
    "k32": "Årligt kassaflöde",
    "k33": "Enhetshyra:",
    "k34": "/ år",
    "k35": "Kontantinsats:",
    "k36": "Spara affär &amp; exportera teaser (kostnadsfritt)",
    "k37": "Inkluderar 125 startkrediter vid registrering. Inget kreditkort krävs."
  },
  "articleDetailPage": {
    "k1": "Fel:",
    "k2": "Artikeln hittades inte.",
    "k3": "CRE Dominion",
    "k4": "Tillbaka till kunskapsnavet",
    "k5": "• Publicerad",
    "k6": "Om författaren",
    "k7": "Hoppa till toppen",
    "k8": "Läs fler artiklar"
  },
  "blogListPage": {
    "k1": "Laddar blogginlägg...",
    "k2": "Fel:",
    "k3": "Kunskapsnav - Expertinsikter inom kommersiella fastigheter | CRE Dominion",
    "k4": "Kunskapsnav",
    "k5": "Föregående sida",
    "k6": "Föregående",
    "k7": "Nästa sida",
    "k8": "Nästa",
    "k9": "Inga blogginlägg tillgängliga ännu. Håll utkik!"
  },
  "adminSEOPage": {
    "k1": "Laddar SEO-administratörspanel...",
    "k2": "Fel:",
    "k3": "Administratörspanel för SEO-automatisering",
    "k4": "Genererade artiklar",
    "k5": "Inga artiklar har genererats ännu."
  },
  "demoPage": {
    "badge": "60-sekunders interaktiv sandlåda",
    "title": "Kommersiell hyresabstraktion och CAM-granskning på några sekunder",
    "subtitle": "Granska automatiskt kommersiella hyresavtal, CAM-avstämningsgränser, KPI-indexklausuler och hyresavvikelser från långa PDF-avtal.",
    "step1Title": "Dokumentuppladdning",
    "step1Desc": "Ladda upp 50+ sidiga kommersiella hyresavtal eller klistra in komplexa CAM- och KPI-eskaleringsklausuler.",
    "step2Title": "AI-klausulabstraktion",
    "step2Desc": "Gemini 3.8 Flash extraherar bashyra, utgiftsstopp, CAM-tak, indexdatum och granskningsfönster.",
    "step3Title": "Granskningstabell & Risker",
    "step3Desc": "Identifierar överdebiteringar, ackumulerade CAM-räntefällor och missade indexjusteringar.",
    "widgetHeader": "Interaktiv analys av hyresklausuler",
    "widgetSub": "Klistra in en hyresklausul eller ladda upp ett PDF-avsnitt nedan för att köra en extraktion i realtid.",
    "liveBadge": "Live backend-slutpunkt",
    "whyTitle": "Varför fastighetsförvaltare förlitar sig på CRE-Dominion",
    "benefit1Title": "1. Noll manuell inmatning av hyresdata",
    "benefit1Desc": "Förvandla 80-sidiga huvudavtal till verifierade nyckelvillkor på 30 sekunder istället för 4 timmar.",
    "benefit2Title": "2. Upptäck CAM-överdebiteringar",
    "benefit2Desc": "Stäm av kontrollerbara kontra icke-kontrollerbara utgiftstak innan årliga avstämningar godkänns.",
    "benefit3Title": "3. Automatiserade KPI-justeringar",
    "benefit3Desc": "Missa aldrig en årlig inflationsjustering eller uppsägningsfrist i din kommersiella portfölj.",
    "ctaText": "Redo att testa CRE-Dominion på din egen kommersiella hyresportfölj?",
    "ctaBtn": "Starta kostnadsfri 14-dagars provperiod ->",
    "signIn": "Logga in",
    "requestPilot": "Begär pilot"
}
,
  "about": {
    "pageTitle": "Om oss & Ledarskap | CRE-Dominion Kommersiell Fastighetsintelligens",
    "navHome": "Hem",
    "navResearch": "Forskning",
    "navContact": "Kontakt",
    "navSignIn": "Logga in",
    "navPilot": "Begär pilot",
    "heroBadge": "Institutionell kommersiell fastighetsintelligens",
    "heroTitle": "Arkitekterad för institutionella förvaltare & mäklare",
    "heroSubtitle": "CRE-Dominion automatiserar kommersiell hyresavtalsabstraktion, driftkostnadsavstämning och algoritmisk affärsanalys. Vi eliminerar manuell friktion så fastighetsoperatörer stänger affärer med empirisk precision.",
    "pillar1Title": "Automatiserad hyresavtalsabstraktion",
    "pillar1Desc": "Extrahera hyresplaner, indexklausuler, optioner och kritiska förfallodatum från 80+ sidors kommersiella avtal på sekunder.",
    "pillar2Title": "Prediktiv kalkylering & underwriting",
    "pillar2Desc": "Algoritmisk värderingsmotor som dynamiskt stresstestar direktavkastningskrav, driftnettotrajektorier och skuldtäckningsgrader mot marknadsdata i realtid.",
    "pillar3Title": "Bankklassad sekretess",
    "pillar3Desc": "Strikt kryptografisk multi-tenant-isolering. Era proprietära hyreslistor, hyresgästkontrakt och proformakalkyler används aldrig för modellträning.",
    "founderLeadership": "Företagsledning",
    "founderName": "Ghazwan Alemara",
    "founderRole": "Grundare & Lead Systems Architect · CRE-Dominion",
    "founderSub": "med stöd av Data Genius",
    "founderLinkedIn": "Anslut på LinkedIn",
    "founderBio1": "Ghazwan Alemara är grundare och Lead Systems Architect för CRE-Dominion, med stöd från den tillämpade mjukvaru- och forskningsstudion Data Genius. Med en bakgrund inom storskalig systemarkitektur och kvantitativ systemutveckling designade Ghazwan CRE-Dominion för att lösa informationsasymmetrin inom kommersiell fastighetsförvaltning och investeringskalkylering.",
    "founderBio2": "Med en masterexamen (M.Sc.) i systemvetenskap från Stockholms universitet (EQF-nivå 7) tillämpar han deterministiska beräkningsmodeller för att ersätta felkänsliga kalkylark med algoritmisk affärsanalys och automatiserad verifiering.",
    "card1Label": "Utbildning",
    "card1Val": "M.Sc. Systemvetenskap",
    "card1Sub": "Stockholms universitet (EQF 7)",
    "card2Label": "Arkitektur",
    "card2Val": "Lead Systems Architect",
    "card2Sub": "Algoritmisk fastighetsintelligens",
    "card3Label": "Utvecklingsstudio",
    "card3Val": "Data Genius",
    "card3Sub": "Tillämpad systemforskning",
    "card4Label": "Dataskydd",
    "card4Val": "Zero-Trust-isolering",
    "card4Sub": "Institutionell integritet",
    "ctaTitle": "Implementera CRE-Dominion i ditt kommersiella bestånd",
    "ctaDesc": "Upplev 60-sekunders avtalsabstraktion och institutionell deal-underwriting på era aktiva affärer genom vårt pilotprogram.",
    "ctaBtn": "Begär institutionell pilot",
    "ctaDemo": "Utforska 60-sekunders demo",
        "secBadge": "Banksekretess & Datasuveränitet",
    "secTitle": "Institutionell säkerhet & nollförtroende-integritet",
    "secSub": "Konstruerad specifikt för institutionella kapitalförvaltare, fastighetsfonder och kommersiella mäklare med strikta sekretesskrav.",
    "secCard1Title": "Ingen AI-modellträning",
    "secCard1Desc": "Dina proprietära hyresavtal, hyreslistor och kalkylmodeller hålls strikt isolerade. Vi tränar aldrig globala AI-modeller på kunddata.",
    "secCard2Title": "AES-256 & TLS 1.3-kryptering",
    "secCard2Desc": "All dokumentinläsning, finansiella böcker och extraktionsflöden krypteras under transport och i vila med automatisk TTL-filradering som tillval.",
    "secCard3Title": "Strikt multi-tenant-isolering",
    "secCard3Desc": "Tillämpad IAM-åtkomstkontroll på arbetsytenivå. Noll dataläckage mellan organisationer, vilket garanterar fullständig affärssekretess.",
    "secCard4Title": "SOC-2 & GDPR-anpassad arkitektur",
    "secCard4Desc": "Fullständig efterlevnad av europeiska och amerikanska dataskyddslagar, oföränderliga revisionsloggar och lokal datasuveränitet.",
    "pilotBadge": "Institutionell riskreducering",
    "pilotTitle": "14-dagars institutionellt pilotramverk",
    "pilotSub": "Utvärdera CRE-Dominion riskfritt på dina aktiva kommersiella förvärv innan du beslutar om fullständig företagsimplementering.",
    "pilotStep1Title": "1. Empiriskt hyresavtalsbenchmark",
    "pilotStep1Desc": "Ladda upp 5-10 av era mest komplexa kommersiella avtal. Mät extraktionshastighet, driftskostnadsfördelning och precision mot era analytiker.",
    "pilotStep2Title": "2. Anpassad kalkylkalibrering",
    "pilotStep2Desc": "Vi kalibrerar värderingsalgoritmer, DCF-kalkylräntor och kassaflödesrapporter för att matcha er investeringskommittés exakta krav.",
    "pilotStep3Title": "3. Direkt suverän ingenjörs-SLA",
    "pilotStep3Desc": "Direktkontakt med chefsystemarkitekt Ghazwan Alemara, garanterad bearbetning under 60 sekunder och prioriterad företagsintegration.",
    "footerRights": "CRE-Dominion · Ett Data Genius-initiativ. Alla rättigheter förbehållna."
}
};
